module.exports = __webpack_public_path__ + "static/sensors-cac115db95a1853f6e299e6a7cb96c16.mp4";